import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router keeps the window scroll position across route changes, so a page
// opened from a scrolled position would start mid-page. Reset to the top on
// every pathname change (skipped when navigating to an in-page #anchor).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
